import ImageGallery from '../../../2compounds/ImageGallery'
import { Reorder } from "framer-motion"

const AdminMode = ({noImage, data}) => {
    return (
        <Reorder.Item key={data.cardId} value={data} data={data} style={{ height: '100%' }}>
            <ImageGallery images={noImage} />
        </Reorder.Item>
    )
}

export default AdminMode
